export default __webpack_public_path__ + "static/media/BendGeometryImg.a35ca9ee.jpg";